import { HandleTextChange, HandleCheckChange, CallAPI, HandleSignatureChange, GetCookieFunction } from '../../utils/util.js';
import React, { Component } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { PatientNav } from './patientnav';
import VoiceInput from '../../utils/VoiceInput';
import Alert from 'react-bootstrap/Alert';

function withRouter(Component) {
    function ComponentWithRouterProp(props) {
        let location = useLocation();
        let navigate = useNavigate();
        let params = useParams();
        return <Component {...props} router={{ location, navigate, params }} />;
    }
    return ComponentWithRouterProp;
}

class CheckOut extends Component {
    constructor(props) {
        super(props);
        this.state = {
            centerID: GetCookieFunction("Center").id,
            patientID: this.props.router.params.patientId,
            Weight: "", SittingBP: "", StandingBP: "", BodyTemp: "",
            RespiratoryRate: "", O2_Saturation: "", Pulse: "",
            Signature: "", time: 0, Assessment: "",
            modalVariant: "", modalMessage: ""
        };
        this.handleTextChange    = HandleTextChange.bind(this);
        this.handleSubmit        = this.handleSubmit.bind(this);
        this.handleCheckChange   = HandleCheckChange.bind(this);
        this.handleSignatureChange = HandleSignatureChange.bind(this);
    }

    handleSubmit(event) {
        event.preventDefault();
        CallAPI(this.state, "patients/checkout", 'POST',
            (res) => {
                if (res.success) {
                    this.props.router.navigate(`/patients/${this.state.patientID}/profile`);
                } else {
                    this.setState({ modalVariant: "danger", modalMessage: "Check-out failed: " + res.message });
                }
            },
            (message) => {
                this.setState({ modalVariant: "danger", modalMessage: "Check-out failed: " + message.message });
            }
        );
    }

    render = () => (
        <div>
            <PatientNav patientId={this.state.patientID} />
            <div className="ci-page">
                <div className="ci-header">
                    <h2>Patient Check-Out</h2>
                    <p>Record post-treatment vitals and complete the visit</p>
                </div>

                {this.state.modalVariant && (
                    <Alert variant={this.state.modalVariant} className="ci-alert">{this.state.modalMessage}</Alert>
                )}

                <form onSubmit={(e) => this.handleSubmit(e)}>
                    <div className="ci-section-title">Post-Treatment Vitals</div>
                    <div className="ci-card">
                        <div className="ci-grid">
                            <div className="ci-field">
                                <label htmlFor="weight" className="ci-required-label">Weight (kg)</label>
                                <input type="text" id="weight" name="Weight" required
                                    pattern="^\d{1,3}(\.\d{0,2})?$" title="e.g. 65 or 65.5"
                                    placeholder="e.g. 65.5"
                                    onChange={(e) => this.handleTextChange(e)} />
                            </div>
                            <div className="ci-field">
                                <label htmlFor="sittingBP" className="ci-required-label">Sitting BP</label>
                                <input type="text" id="sittingBP" name="SittingBP" required
                                    pattern="\d{1,3}\/\d{1,3}" maxLength="7" title="e.g. 120/80"
                                    placeholder="120/80"
                                    onChange={(e) => this.handleTextChange(e)} />
                            </div>
                            <div className="ci-field">
                                <label htmlFor="standingBP">Standing BP</label>
                                <input type="text" id="standingBP" name="StandingBP"
                                    pattern="\d{1,3}\/\d{1,3}" maxLength="7"
                                    placeholder="120/80"
                                    onChange={(e) => this.handleTextChange(e)} />
                            </div>
                            <div className="ci-field">
                                <label htmlFor="body_temp" className="ci-required-label">Body Temp (°F)</label>
                                <input type="text" id="body_temp" name="BodyTemp" required
                                    pattern="^\d+(\.\d)?$" placeholder="98.6"
                                    onChange={(e) => this.handleTextChange(e)} />
                            </div>
                            <div className="ci-field">
                                <label htmlFor="resp_rate" className="ci-required-label">Respiratory Rate</label>
                                <input type="number" id="resp_rate" name="RespiratoryRate" required
                                    placeholder="breaths/min"
                                    onChange={(e) => this.handleTextChange(e)} />
                            </div>
                            <div className="ci-field">
                                <label htmlFor="O2_Saturation">O₂ Saturation (%)</label>
                                <input type="number" id="O2_Saturation" name="O2_Saturation"
                                    placeholder="e.g. 98"
                                    onChange={(e) => this.handleTextChange(e)} />
                            </div>
                            <div className="ci-field">
                                <label htmlFor="pulse">Pulse Rate (BPM)</label>
                                <input type="number" id="pulse" name="Pulse"
                                    placeholder="e.g. 72"
                                    onChange={(e) => this.handleTextChange(e)} />
                            </div>
                        </div>
                    </div>

                    <div className="ci-section-title">Assessment &amp; Signature</div>
                    <div className="ci-card">
                        <div className="ci-field">
                            <label htmlFor="Assessment">Assessment Notes</label>
                            <div className="ci-field-with-voice">
                                <textarea id="Assessment" name="Assessment" maxLength="500" rows={3}
                                    placeholder="Post-treatment assessment..."
                                    value={this.state.Assessment}
                                    onChange={(e) => this.handleTextChange(e)} />
                                <VoiceInput language="en" onTranscript={(text) => {
                                    this.setState(prev => ({
                                        Assessment: (prev.Assessment || "") + (prev.Assessment ? " " : "") + text
                                    }));
                                }} />
                            </div>
                        </div>
                    </div>

                    <div className="ci-card">
                        <label className="ci-checkbox-label ci-signature">
                            <input type="checkbox" required name="Signature"
                                onChange={(e) => { this.handleCheckChange(e); this.handleSignatureChange(e, this); }}
                                value="unchecked" />
                            <span>I confirm the above information is accurate <em>(electronic signature)</em></span>
                        </label>
                    </div>

                    <div className="ci-submit-row">
                        <button type="submit" className="logSubmit ci-submit-btn">Confirm Check-Out</button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default withRouter(CheckOut);
